import { render, staticRenderFns } from "./DocumentosTributariosComisiones.vue?vue&type=template&id=5b909c42&scoped=true&"
import script from "./DocumentosTributariosComisiones.vue?vue&type=script&lang=js&"
export * from "./DocumentosTributariosComisiones.vue?vue&type=script&lang=js&"
import style0 from "./DocumentosTributariosComisiones.vue?vue&type=style&index=0&id=5b909c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b909c42",
  null
  
)

export default component.exports